import { useContext } from 'react';
import { ClearFiltersButton } from 'components/filter/ClearFiltersButton';
import { Filter } from 'components/filter/filters-next/Filter';
import { FilterProviderContext } from 'components/filter/filters-next/FilterProvider';
import {
    QuickFiltersBar,
    QuickFiltersBarProps,
} from 'components/filter/filters-next/QuickFiltersBar';

interface FilterBarProps extends QuickFiltersBarProps {}

const FilterBar = (props: FilterBarProps) => {
    const { quickFilters: quickFilterKeys = [] } = props;
    const { resource, cacheKey, readOnly } = useContext(FilterProviderContext);

    return (
        <div className={'flex flex-wrap items-center gap-2'}>
            <QuickFiltersBar quickFilters={quickFilterKeys} />
            <Filter resource={resource} cacheKey={cacheKey} readOnly={readOnly} />
            <ClearFiltersButton />
        </div>
    );
};

export { FilterBar };
